module.exports = __webpack_public_path__ + "static/media/logo-googlePartner-min.731b6ed3.webp";